module.exports = function () {
    if ($('.person-detail').length) {
        var $quote = $('.person-detail-content__quote');
        var $bio = $('.person-detail-content__bio');

        if ($quote.length && $bio.length) {
            var $paragraphs = $bio.find('p');

            if ($paragraphs.length > 1) {
                var $firstParagraph = $paragraphs.first();

                $firstParagraph.after($quote);
            }
        }

        $('.person-detail-header__cta').modaal({
            overlay_opacity: 0.8,
            close_text: 'esc',
            custom_class: 'modaal-wrapper--spacingless modaal-wrapper--no-close-btn',
            content_source: '#marketoModalContent',
            after_open: function(modal_wrapper) {
                var $content = $(modal_wrapper);

                var $closeCTA = $content.find('.person-detail-modal__close-cta');

                $closeCTA.click(function () {
                    $('.person-detail-header__cta').modaal('close');
                });
            }
        });

        $('.person-detail-header__cta').click(function (e) {
            e.preventDefault();

            $(this).modaal('open');
        });

        var $showMoreNewsCTA = $('.person-detail-featured-news__show-all-cta');
        $showMoreNewsCTA.click(function (e) {
            e.preventDefault();

            $('.person-detail-featured-news-item').removeClass('person-detail-featured-news-item--hidden');
            $('.person-detail-featured-news__show-all-cta-wrapper').remove();
        });

        var $showMoreInsightsCTA = $('.person-detail-insights__show-all-cta');
        $showMoreInsightsCTA.click(function (e) {
            e.preventDefault();

            $('.person-detail-insights').find('.universal-grid-item').removeClass('universal-grid-item--hidden');
            $('.person-detail-insights__show-all-cta-wrapper').remove();
        });

        var channelTooltip = tippy('.person-detail-header__organization--with-tooltip', {
            maxWidth: '100%',
            content: document.getElementById('person-detail-header__organization-content'),
            placement: 'bottom-start',
            flip: false,
            onMount: function (instance) {
                var $instance = $(instance.popper);
                var $closeCTA = $instance.find('.popover__close-cta');
                $closeCTA.unbind('click');

                $closeCTA.click(function () {
                    instance.hide();
                });
            }
        })[0];
    }
};